<template>
  <div class="zn-panel" @click.self="$emit('closePanel', $event)">
    <div class="zn-panel-modal"
      :style="`width: ${width}; 
        ${height?('height:'+height):''};`"
    >
      <div class="zn-panel-header">
        <div class="zn-panel-back">
          <div class="zn-panel-back-btn" v-if="backable" @click="$emit('back')"><Icon name="arrow_back" /></div>
        </div>
        <div class="zn-panel-title zn-bold"><Icon v-if="icon" :name="icon" />{{title}}</div>
        <div class="zn-panel-actions">
          <div class="zn-panel-filter" v-if="searchable">
            <Icon name="search" />
            <input type="text" placeholder="Search..." :value="searchQuery" @input="$emit('search', $event.target.value)" />
          </div>
          <div class="zn-panel-close-btn" @click="$emit('closePanel')"><Icon name="close" /></div>
        </div>
      </div>
      <div class="zn-panel-body">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import Icon from './Icon'

export default {
  components: { Icon },
  props: {
    title: String,
    icon: String,
    width: {
      type: String,
      default: '300px'
    },
    height: {
      type: String
    },
    backable: {
      type: Boolean
    },
    searchable: {
      type: Boolean
    },
    searchQuery: {
      type: String,
      value: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.zn-panel {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(black, 0.3);
  z-index: 9999;

  .zn-panel-modal {
    max-width: 100%;
    position: absolute;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);
    background-color: white;
    border-radius: 5px;
    display: flex;
    flex-direction: column;

    .zn-panel-header {
      padding: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 2px solid $light;

      .zn-panel-back-btn {
        display: flex;
        align-items: center;
        cursor: pointer;
        .material-icons-outlined {
          font-size: 28px;
        }
      }

      .zn-panel-title {
        color: $primary;
        font-size: 18px;
        display: flex;
        align-items: center;
        ::v-deep i {
          margin-right: 8px;
        }
      }

      .zn-panel-actions {
        display: flex;
        align-items: center;
        .zn-panel-filter {
          margin-right: 16px;
          .material-icons-outlined {
            position: relative;
            top: 5px;
            left: 24px;
            font-size: 21px;
          }
          input {
            width: 240px;
            padding: 6px 16px 6px 24px;
            border: 1px solid $fade;
            border-radius: 5px;
            font-size: 16px;
          }
        }

        .zn-panel-close-btn {
          font-size: 24px;
          cursor: pointer;
          padding: 4px;
          border-radius: 50%;
          height: 32px;
          transition: background-color 0.25s;
        }
      }
    }

    .zn-panel-body {
      padding: 8px 16px;
      overflow-y: auto;
      border-radius: 0 0 5px 5px;
      height: 100%;
    }
  }
}
</style>